// Thin fetch wrapper — no HTTP client library needed for this surface.
// `credentials: 'include'` sends the session cookie; the admin dev server
// (and, in production, Nginx) proxies /api to the same origin as this
// app, which is what makes the SameSite=Strict cookie work at all.
export class ApiError extends Error {
  constructor(message, status, code, details) {
    super(message);
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

async function request(path, { method = 'GET', body, isFormData = false } = {}) {
  const res = await fetch(path, {
    method,
    credentials: 'include',
    headers: isFormData ? undefined : body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: isFormData ? body : body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (res.status === 204) return null;

  const contentType = res.headers.get('content-type') || '';
  const data = contentType.includes('application/json') ? await res.json() : null;

  if (!res.ok) {
    const err = data?.error;
    throw new ApiError(err?.message || 'Something went wrong. Please try again.', res.status, err?.code, err?.details);
  }
  return data;
}

export const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: 'POST', body: body ?? {} }),
  patch: (path, body) => request(path, { method: 'PATCH', body }),
  put: (path, body) => request(path, { method: 'PUT', body }),
  delete: (path) => request(path, { method: 'DELETE' }),
  upload: (path, formData) => request(path, { method: 'POST', body: formData, isFormData: true }),
};
